<template>
	<div class="setting-advanced-evil-ip">
		<div class="module-item-style">
			<div class="module-item-title">IP黑名单</div>
			<div class="module-item-tips">新增或修改时，请填写外网 IP 段(同一 C 段)或某个固定外网 IP 地址</div>
			<div class="evil-ip-container">
				<div class="evil-add-wrap">
					<el-input v-model="ipBegin" :placeholder="ipPlaceholder"></el-input>
					<span v-if="ipType==2">至</span>
					<el-input v-model="ipEnd" placeholder="请输入IP段结束地址" v-if="ipType==2"></el-input>
					<el-select v-model="expiredAt" placeholder="请选择">
						<el-option v-for="item in expireList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<div class="wl-btn add" @click="addEvilIp">添加</div>
				</div>
				<div class="ipType-wrap">
					<span v-if="ipType==1" @click="changeIpType">切换为 IP 段输入模式</span>
					<span v-if="ipType==2" @click="changeIpType">切换为 IP 输入模式</span>
				</div>

			</div>
		</div>
		<div class="module-item-style">
			<div class="search-box">
				<el-input clearable v-model="searchIp" placeholder="请输入要查询的IP地址"></el-input>
				<div class="wl-btn add" @click="searchBlackList">查询</div>
			</div>
			<div class="table-box">
				<el-table ref="multipleTable" :data="tableData" stripe :header-cell-style="{background:'#f2f2f2'}" style="border: 1px solid #ebeef5;"
				 @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="55">
					</el-table-column>
					<el-table-column label="IP地址">
						<template slot-scope="scope">
							<span>{{scope.row.ipBegin}}</span>
							<span v-if="scope.row.ipBegin!=scope.row.ipEnd">至</span>
							<span v-if="scope.row.ipBegin!=scope.row.ipEnd">{{scope.row.ipEnd}}</span>
						</template>
					</el-table-column>
					<el-table-column label="屏蔽到期时间">
						<template slot-scope="scope">
							<span>{{scope.row.expiredAtStr.split("-")[0]>2100 ? "长期屏蔽" : scope.row.expiredAtStr}} </span>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<button class="tb-btn tb-btn-edit" @click="showEditDialog(scope.row)">编辑</button>
							<button class="tb-btn tb-btn-del" @click="removeIpBlackList('delSingle',scope.row.ipBlacklistId)">移除</button>
						</template>
					</el-table-column>
				</el-table>
				<div style="margin-top: 20px;padding-left: 14px;" v-if="tableData.length > 0">
					<el-checkbox v-model="checkAll" @change="toggleSelection()"></el-checkbox>
					<span class="wl-btn-del ml20" @click="removeIpBlackList('delAll',SelectionData)">批量删除</span>
				</div>
				<!--    分页-->

				<pagenations :total="total" :size="pageSize" @pageHandler="pageOperate">
				</pagenations>
			</div>
		</div>
		<el-dialog title="编辑IP黑名单" class="ip-blacklist-dialog" width="500px" :visible.sync="dialogFormVisible">
			<div class="form-wrap">
				<div class="ip-input-wrap">
					<el-input v-model="formData.ipBegin" :placeholder="formData.ipPlaceholder"></el-input>
					<span v-if="formData.ipType==2">至</span>
					<el-input v-model="formData.ipEnd" placeholder="请输入IP段结束地址" v-if="formData.ipType==2"></el-input>
				</div>
				<div class="ipType-wrap">
					<span v-if="formData.ipType==1" @click="changeDialogIpType">切换为 IP 段输入模式</span>
					<span v-if="formData.ipType==2" @click="changeDialogIpType">切换为 IP 输入模式</span>
				</div>

				<el-select v-model="formData.expiredAt" placeholder="请选择">
					<el-option v-for="item in expireList" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="editEvilIp">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import pagenations from '@/components/pagenations/pagenations'
	export default {
		name: 'setting-advanced-ip-IpBlackList',
		components: {
			pagenations
		},
		data() {
			return {
				ipBegin: "",
				ipEnd: "",
				ipType: 1, // 1为固定ip 2为ip段
				ipPlaceholder: "请输入IP地址",
				searchIp: "",
				expiredAt: "长期屏蔽",
				expireList: [{
					value: 0,
					label: '长期屏蔽'
				}, {
					value: 0.5,
					label: '屏蔽半小时'
				}, {
					value: 1,
					label: '屏蔽1小时'
				}, {
					value: 2,
					label: '屏蔽2小时'
				}, {
					value: 6,
					label: '屏蔽6小时'
				}, {
					value: 24,
					label: '屏蔽24小时'
				}, {
					value: 24 * 7,
					label: '屏蔽7天'
				}],
				tableData: [],
				total: 0,
				currentPage: 1,
				pageSize: 10,
				checkAll: '',
				SelectionData: [],
				dialogFormVisible: false,
				formData: {
					ipBlacklistId: "",
					ipBegin: "",
					ipEnd: "",
					expiredAt: "长期屏蔽",
					ipType: 1
				}
			}
		},
		created() {
			this.getIpBlackListData()
		},
		mounted() {

		},
		methods: {
			handleSelectionChange(val) {
				if (val.length > 0) {
					this.checkAll = true
				} else {
					this.checkAll = false
				}
				this.SelectionData = val
			},
			toggleSelection() {
				if (this.checkAll) {
					this.$refs.multipleTable.toggleAllSelection();
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			changeIpType() {
				this.ipEnd = ""
				this.ipType == 1 ? this.ipType = 2 : this.ipType = 1
				this.ipType == 1 ? this.ipPlaceholder = "请输入IP地址" : this.ipPlaceholder = "请输入IP段开始地址"
			},
			changeDialogIpType() {
				this.formData.ipType == 1 ? this.formData.ipType = 2 : this.formData.ipType = 1
				this.formData.ipType == 1 ? this.formData.ipPlaceholder = "请输入IP地址" : this.formData.ipPlaceholder = "请输入IP段开始地址"
			},
			showEditDialog(data) {
				console.log(data)
				this.dialogFormVisible = true
				this.formData.ipBlacklistId = data.ipBlacklistId
				this.formData.ipBegin = data.ipBegin
				this.formData.ipEnd = data.ipEnd
				this.formData.ipType = data.ipBegin == data.ipEnd ? 1 : 2
				console.log(this.formData)
			},
			/**
			 *  分页操作
			 * @param val
			 */
			pageOperate(val) {
				if (val.type == 'currentChange') {
					this.currentPage = val.val
				} else if (val.type == "sizeChange") {
					this.pageSize = val.val
				}
				this.getIpBlackListData()
			},
			searchBlackList() {
				if (!this.isValidIP(this.searchIp) && this.searchIp) {
					this.$message.error("请输入正确的IP地址")
					return false
				}
				this.getIpBlackListData()
			},
			getIpBlackListData() {
				this.$http.getIpBlackListAPI({
					pageSize: this.pageSize,
					pageNum: this.currentPage,
					ip: this.searchIp,
					active: 1
				}).then(res => {
					if (res.status == 1) {
						this.tableData = res.data.ipBlackList
						this.total = res.data.total
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
						})
					}
				})
			},
			/**
			 * 移除黑名单
			 * @param id
			 */
			removeIpBlackList(type, id) {
				let idArr = []
				if (type == "delSingle") {
					idArr.push(id)
				} else if (type == "delAll") {
					if (id.length == 0) {
						this.$message({
							message: '请选择要删除的数据',
							type: 'error'
						})
						return false
					}
					id.forEach((item, index) => {
						idArr.push(item.ipBlacklistId)
					})
				}
				this.$http.delIpBlackAPI(idArr).then(res => {
					if (res.status == 1) {
						this.getIpBlackListData()
						this.$message({
							message: res.msg,
							type: 'success',
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'error',
						})
					}
				})
			},
			addEvilIp() {
				if (!this.isValidIP(this.ipBegin)) {
					this.ipType == 1 ? this.$message.error("请输入正确的IP地址") : this.$message.error("请输入正确的IP段开始地址")
					return false
				}
				if (this.ipType == 2) {
					if (!this.isValidIP(this.ipEnd)) {
						this.$message.error("请输入正确的IP段结束地址")
						return false
					}
				} else {
					this.ipEnd = this.ipBegin
				}
				let postData = {
					ipBegin: this.ipBegin,
					ipEnd: this.ipEnd
				}
				let nowTimestamp = Date.parse(new Date()) / 1000;
				if (this.expiredAt == "长期屏蔽" || this.expiredAt == 0) {
					// 长期屏蔽
					postData.expiredAt = 9999999999

				} else {
					postData.expiredAt = nowTimestamp * 1 + this.expiredAt * 60 * 60
				}
				this.$http.addIpBlackAPI(postData).then(res => {
					console.log(res)
					if (res.status == 1) {
						this.getIpBlackListData()
						this.$message({
							message: "添加成功",
							type: 'success'
						})
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			editEvilIp() {
				console.log(this.formData.expiredAt)
				if (!this.isValidIP(this.formData.ipBegin)) {
					this.formData.ipType == 1 ? this.$message.error("请输入正确的IP地址") : this.$message.error("请输入正确的IP段开始地址")
					return false
				}
				if (this.formData.ipType == 2) {
					if (!this.isValidIP(this.formData.ipEnd)) {
						this.$message.error("请输入正确的IP段结束地址")
						return false
					}
				} else {
					this.formData.ipEnd = this.formData.ipBegin
				}
				let postData = {
					ipBlacklistId: this.formData.ipBlacklistId,
					ipBegin: this.formData.ipBegin,
					ipEnd: this.formData.ipEnd
				}
				let nowTimestamp = Date.parse(new Date()) / 1000;
				if (this.formData.expiredAt == "长期屏蔽" || this.formData.expiredAt == 0) {
					// 长期屏蔽
					postData.expiredAt = 9999999999

				} else {
					postData.expiredAt = nowTimestamp * 1 + this.formData.expiredAt * 60 * 60
				}
				this.$http.editIpBlackAPI(postData).then(res => {
					console.log(res)
					if (res.status == 1) {
						this.dialogFormVisible = false
						this.getIpBlackListData()
						this.$message({
							message: "添加成功",
							type: 'success'
						})
						this.formData.ipBlacklistId = ""
						this.formData.ipBegin = ""
						this.formData.ipEnd = ""
						this.formData.ipType = 1
						this.formData.expiredAt = "长期屏蔽"
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			// 验证ip地址是否正确
			isValidIP(ip) {
				let reg =
					/^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
				return reg.test(ip)
			},
			// ip地址转换为整数
			_ip2int(ip) {
				let num = 0;
				ip = ip.split(".");
				num = Number(ip[0]) * 256 * 256 * 256 + Number(ip[1]) * 256 * 256 + Number(ip[2]) * 256 + Number(ip[3]);
				num = num >>> 0;
				return num;
			},
		}
	}
</script>

<style lang="scss">
	.evil-add-wrap {
		display: flex;
		align-items: center;
		padding: 15px 0 5px;

		.el-input {
			width: 240px;
		}

		.el-select {
			margin-left: 20px;
			width: 160px;

			.el-input {
				width: 160px;
			}
		}

		span {
			margin: 0 5px;
		}

		.wl-btn.add {
			margin-left: 20px;
		}
	}

	.ipType-wrap {
		span {
			margin: 0 5px;
			color: $mainColor;
			font-size: 12px;
			cursor: pointer;
		}
	}

	.search-box {
		display: flex;

		.el-input {
			width: 240px;
		}

		.wl-btn.add {
			margin-left: 20px;
		}
	}

	.wl-btn-del.ml20 {
		margin-left: 20px;
	}

	.form-wrap {
		.el-input {
			width: 200px;
		}

		span {
			margin: 0 5px;
		}

		.el-select {
			width: 160px;

			.el-input {
				width: 160px;
			}
		}

		.ip-input-wrap {
			margin-bottom: 5px;
		}

		.ipType-wrap {
			margin-bottom: 20px;
		}
	}
</style>
